import { BaseResponse } from '../response/BaseResponse';
import { AgmsResponseCode } from '../../enum/AgmsResponseCode';

export interface StatsResponse extends BaseResponse {
  Items: Stats[];
}

export interface Stats {
  Client: string;
  Company: string;
  Region: string;
  Group: string;
  Location: string;
  LocationID: string;
  PaymentSource: string | null;
  CCY: string;
  Bet: number;
  BetTax: number;
  BetAfterTax: number;
  Payout: number;
  PayoutTax: number;
  PayoutAfterTax: number;
  Win: number;
  WinTax: number;
  WinAfterTax: number;
  ForPayout: number;
  ForPayoutTax: number;
  ForPayoutAfterTax: number;
  GGR: number;
  Balance: number;
  Percentage: number;
  AverageStake: number;
  NumberOfPayInTickets: number;
  NumberOfPayoutTickets: number;
  NumberOfDeletedTickets: number;
  NumberOfTickets: number;
}

export const searchStats = (
  data: Stats[],
  searchTerm: string,
) => {
  const term = searchTerm.toLowerCase();
  const fields: (keyof Stats)[] = ['Location', 'Client', 'Company', 'Group'];

  return {
    Items: data.filter(item =>
      fields.some(field => {
        const value = item[field];
        if (value === null || value === undefined) return false;
        return value.toString().toLowerCase().includes(term);
      }),
    ),
    Message: '',
    ResponseCode: AgmsResponseCode.OK,
  } as StatsResponse;
};
